import { Form } from 'antd';

import Input from '@/components/Inputs/Input';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const SubredditField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <Form.Item
      label="Subreddit"
      name={SCRAPER_REQ_FIELD_KEY.SUBREDDIT}
      required={required}
      rules={
        required ? [{ required: true, message: 'Subreddit is required' }] : []
      }
    >
      <Input placeholder="Type subreddit" sizeType="m" />
    </Form.Item>
  );
};
